import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonBlockComponent } from '../../general/skeleton/skeleton-block/skeleton-block.component';
import { MatSelectModule } from '@angular/material/select';
import { LANGUAGES } from '@core/constants';
import { MatButtonModule } from '@angular/material/button';

import { UserStore } from '@root/app/store/user.store';

@Component({
  selector: 'xemex-terms-dialog',
  imports: [SkeletonBlockComponent, TranslateModule, MatSelectModule, MatButtonModule],
  providers: [UserStore],
  templateUrl: './terms-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './terms-dialog.component.scss',
})
export class TermsDialogComponent {
  readonly userStore = inject(UserStore);
  LANGUAGES = LANGUAGES;
  language: string = 'EN';

  constructor(public dialogRef: MatDialogRef<TermsDialogComponent>) {
    effect(() => {
      if (this.userStore.user().language) {
        this.language = this.userStore.user().language;
      }
    });
  }

  onChangeLanguage(lang: string) {
    this.language = lang;
  }

  onPrint() {}

  onAccept() {}

  onDecline() {}
}
